import api from '@/api/app'
import { setTokenExp } from '@/utils/auth'
// import { resolve } from 'core-js/fn/promise'

const system = {
  global: {
    viewInfo: {
      tableHead: {
        'background-color': '#f5f9fd',
        color: '#2778fb'
      }
    },
    form: {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() + 3600 * 1000 * 24 < Date.now()
        }
      }
    },
    control: {

    }
  },
  login: {
    viewInfo: {
      obj: {
        rules: {
          user_name: [
            { required: true, message: '请输入账号', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ],
          captcha: [
            { required: true, message: '请输入验证码', trigger: 'blur' }
          ],
          // phone: [
          //   { required: true, message: '请输入手机号', trigger: 'blur' }
          // ],
          code: [
            { required: true, message: '请输入验证码', trigger: 'blur' }
          ]
        }
      },
      data: {}
    },
    control: {

    },
    init: {
      initConfigs: [
        {
          label: 'searchData1',
          model: null
        },
        {
          label: 'searchData2',
          model: null
        },
        {
          label: 'searchData3',
          model: null
        },
        {
          label: 'searchData4',
          model: 'params'
        },
        {
          label: 'notesData5',
          model: 'params'
        },
        {
          label: 'notesData6',
          model: 'params'
        },
        {
          label: 'notesData7',
          model: 'params'
        }
      ],
      handleCheckImg: () => {
        return new Promise((resolve) => {
          api.system.captcha().then((res) => {
            resolve(res.data)
          })
        })
      },
      handleSubmit: (obj) => {
        return new Promise((resolve) => {
          api.system.login(obj).then((res) => {
            setTokenExp(res.data.token, res.data.expires_in)
            api.mine.retrieve.dto({ token: res.data.token }).then((v) => {
              localStorage.setItem('user', JSON.stringify(v.data))
              resolve(v.data)
            })
          })
          // api.system.loginpwd(obj).then((res) => {
          //     setTokenExp(res.data.token, res.data.expires_in);
          //     api.mine.retrieve.dto({ token: res.data.token }).then((v) => {
          //         localStorage.setItem("user", JSON.stringify(v.data));
          //         resolve(v.data);
          //     });
          // })
        })
      },
      handleWxLogin: (obj) => {
        return new Promise((resolve) => {
          api.system.wx(obj).then((res) => {
            resolve(res.data)
          })
        })
      }
    }
  },
  register: {
    viewInfo: {
      obj: {
        progressList: ['选择角色', '填写个人信息', '完成注册'],
        roleList: [
          {
            label: '我是管理者',
            id: 2
          },
          {
            label: '我是校方',
            id: 1
          }
        ],
        rules1: {
          username: [
            {
              required: true, message: '请输入用户名', trigger: 'blur'
            }
          ],
          phone: [
            {
              required: true, message: '请输入手机号', trigger: 'blur'
            }
          ],
          password: [
            {
              required: true, message: '请输入密码', trigger: 'blur'
            }
          ],
          password_confirm: [
            {
              required: true, message: '请再次输入密码', trigger: 'blur'
            }
          ],
          captcha: [
            {
              required: true, message: '请输入图片验证码', trigger: 'blur'
            }
          ],
          code: [
            {
              required: true, message: '请输入短信验证码', trigger: 'blur'
            }
          ]
        }
      }

    },
    control: {

    },
    init: {
      initConfigs: [
        {
          label: 'searchData1',
          model: null
        },
        {
          label: 'searchData2',
          model: null
        },
        {
          label: 'searchData3',
          model: null
        },
        {
          label: 'searchData4',
          model: 'params'
        },
        {
          label: 'notesData5',
          model: 'params'
        },
        {
          label: 'notesData6',
          model: 'params'
        },
        {
          label: 'notesData7',
          model: 'params'
        }
      ],
      name: (obj) => {
        return new Promise((resolve) => {
          api.school.retrieve.name(obj).then((res) => {
            resolve(res.data.school_name)
          })
        })
      },
      handleCheckImg: () => {
        return new Promise((resolve) => {
          api.system.captcha().then((res) => {
            resolve(res.data)
          })
        })
      },
      handleSubmit: (obj) => {
        return new Promise((resolve) => {
          api.system.register(obj).then((res) => {
            setTokenExp(res.data.token, res.data.expires_in)
            api.mine.retrieve.dto({ token: res.data.token }).then((v) => {
              localStorage.setItem('user', JSON.stringify(v.data))
              resolve(v.data)
            })
          })
        })
      }
    }
  },
  password: {
    viewInfo: {
      obj: {
        tabsList: [
          {
            id: 111,
            key: 0,
            name: '重置密码',
            type: 'text'
          }
          // {
          //     id: 222,
          //     name: "",
          //     type: "text",
          // },
          // {
          //     id: 333,
          //     name: "",
          //     type: "text",
          // },
        ],
        rules1: {
          phone: [
            {
              required: true, message: '请输入手机号', trigger: 'blur'
            }
          ],
          password: [
            {
              required: true, message: '请输入密码', trigger: 'blur'
            }
          ],
          password_confirm: [
            {
              required: true, message: '请再次输入密码', trigger: 'blur'
            }
          ],
          captcha: [
            {
              required: true, message: '请输入图片验证码', trigger: 'blur'
            }
          ],
          code: [
            {
              required: true, message: '请输入短信验证码', trigger: 'blur'
            }
          ]
        }
      },
      data: [

      ]
    },
    control: {

    },
    init: {
      initConfigs: [
        {
          label: 'searchData1',
          model: null
        },
        {
          label: 'searchData2',
          model: null
        },
        {
          label: 'searchData3',
          model: null
        },
        {
          label: 'searchData4',
          model: 'params'
        },
        {
          label: 'notesData5',
          model: 'params'
        },
        {
          label: 'notesData6',
          model: 'params'
        },
        {
          label: 'notesData7',
          model: 'params'
        }
      ],
      handleCheckImg: () => {
        return new Promise((resolve) => {
          api.system.captcha().then((res) => {
            resolve(res.data)
          })
        })
      }
    }
  }
}
export default system
